/**
 * Höchstzahl der Tickets in EINEM Präsentations-Deck.
 *
 * Spiegelt `issueKeysSchema` (`z.array(jiraKeySchema).min(1).max(50)` in
 * `packages/shared/src/customerView.ts`) — dort steht die Grenze für alle
 * Deck-Operationen (Zusammenfassungen, Protokoll). Hier steht dieselbe Zahl,
 * damit die Oberfläche bremst, bevor der Server ablehnt: Ein Deck aus 60
 * Tickets scheiterte sonst erst nach dem Klick auf „Zusammenfassungen
 * erzeugen“, mit einer Meldung, die nicht sagt, woran es lag.
 *
 * Wer die Zahl ändert, ändert sie in `@msc/shared` mit — sonst bremst die
 * Oberfläche zu früh oder gar nicht.
 */
export const DECK_MAX = 50;
